import { Link as MuiLink, LinkProps } from '@mui/material';
import { ReactNode } from 'react';

interface BaseLinkProps extends Omit<LinkProps, 'children'> {
  children: ReactNode;
}

export function Link({ children, ...otherProps }: BaseLinkProps) {
  return <MuiLink {...otherProps}>{children}</MuiLink>;
}
